import React from 'react';
import classNames from 'classnames';

import SummaryMetrics from './SummaryMetrics';
import * as styles from './styles/styles.module.scss';

const Dashboard = (): JSX.Element => {
  const content1 = 'this';
  const content2 = 'is';
  const content3 = 'placeholder';
  const content4 = 'content';

  return (
    <div className={styles.wrapper}>
      <SummaryMetrics />
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={classNames(styles.widget, styles.contentWidget)}>
            <h3 className={styles.widgetTitle}>Most popular trails</h3>
            <p style={{ height: '250px' }}>{content1}</p>
          </div>
          <div className={classNames(styles.widget, styles.contentWidget)}>
            <h3 className={styles.widgetTitle}>Reviews</h3>
            <p style={{ height: '250px' }}>{content2}</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className={classNames(styles.widget, styles.contentWidget)}>
            <h3 className={styles.widgetTitle}>Page views trend</h3>
            <p style={{ height: '250px' }}>{content3}</p>
          </div>
          <div className={classNames(styles.widget, styles.contentWidget)}>
            <h3 className={styles.widgetTitle}>Conditions</h3>
            <p style={{ height: '250px' }}>{content4}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
